<template>
    <div class="container mt-5">
      <h2 class="mb-4">Seller Payment Table</h2>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Payment ID</th>
            <th>Seller ID</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="payment in payments" :key="payment.id">
            <td>{{ payment.id }}</td>
            <td>{{ payment.sellerId }}</td>
            <td>{{ payment.amount }}</td>
            <td>{{ payment.date }}</td>
            <td>{{ payment.status }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PaymentTable',
    data() {
      return {
        payments: [
          { id: 1, sellerId: 101, amount: 500, date: '2024-06-01', status: 'Completed' },
          { id: 2, sellerId: 102, amount: 300, date: '2024-06-15', status: 'Pending' },
          { id: 3, sellerId: 103, amount: 700, date: '2024-07-01', status: 'Completed' },
          // Add more payment records as needed
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .table {
    width: 100%;
  }
  </style>
  